<template>
  <div id="weeklyReports" class="margin-subpages">
    <div class="fs-18 fw-700">{{ $t("reports.WEEKLY_REPORT_PREVIEW") }}</div>
    <div class="line-section"></div>
    <div class="flex-center">
      <div class="mr-16">
        <el-cascader
          v-model="managerSelected"
          :placeholder="$t('reports.Select_a_Manager')"
          :options="managerList"
          :filter-method="filterManagerFunction"
          filterable
          clearable
        >
        <template slot-scope="{ node, data }">
          <span class="fs-14">{{ data.firstname }} {{ data.lastname }}</span>
        </template>
        </el-cascader>
      </div>
      <div>
        <el-date-picker
          v-model="dateSelected"
          type="date"
          format="ddd, MMMM d, yyyy"
          value-format="yyyy-MM-dd"
          style="widht: 320px"
          :placeholder="$t('reports.Select_date')"
          ref="datepicker_weekly"
          :picker-options="pickerOptions"
          placement="bottom-start"
        >
        </el-date-picker>
        <!-- <el-cascader
          v-model="dateSelected"
          placeholder="Select a Date"
          :options="dateList"
          style="widht: 320px"
          filterable
        >
        </el-cascader> -->
      </div>
      <div class="pl-20" v-if="this.inforWeeklyData && this.inforWeeklyData.file">
        <svg
          @click="exportReport()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
      </div>
    </div>
    <div class="flex-center fs-16 mt-32">
      <div class="flex-center">
        <span class="fw-700 mr-16">{{ $t("reports.Delivery_Status") }}:</span>
        <div
          v-if="inforWeeklyData.deliveryStatus === 'none'"
          class="flex-center"
          style="width: 150px"
        >
          <div class="status status-gray mr-8"></div>
          <div
            class="text-pending mr-2"
            style="width: 90px; height: 16px"
          ></div>
        </div>
        <div
          v-else-if="inforWeeklyData.deliveryStatus === 'undelivered'"
          class="flex-center"
          style="width: 150px"
        >
          <div class="status status-red mr-8"></div>
          {{ $t("reports.Undelivered") }}
        </div>
        <div
          v-else-if="inforWeeklyData.deliveryStatus === 'delivered'"
          class="flex-center"
          style="width: 150px"
        >
          <div class="status status-green mr-8"></div>
          {{ $t("reports.Delivered") }}
        </div>
        <div v-else class="flex-center" style="width: 150px">
          <div class="status status-gray mr-8"></div>
          <div
            class="text-pending mr-2"
            style="width: 90px; height: 16px"
          ></div>
        </div>
      </div>
      <div class="flex-center" v-if="managerSelected && dateSelected">
        <div v-if="inforWeeklyData.deliveryStatus === 'undelivered'">
          <span class="fw-700 mr-16">Issue:</span>
          <span style="width: 150px">{{ inforWeeklyData.issue }}</span>
        </div>
        <div v-else-if="inforWeeklyData.deliveryStatus === 'delivered'" class="flex-center">
          <span class="fw-700 mr-16">{{ $t("reports.Read_Status") }}:</span>
          <div v-if="inforWeeklyData.readStatus" class="status status-green mr-8"></div>
          <div v-else class="status status-red mr-8"></div>
          <span>{{ inforWeeklyData.readStatus }}</span>
        </div>
      </div>
    </div>
    <div class="mock-email" v-if="managerSelected && dateSelected && inforWeeklyData.preview">
      <div class="body-email center">
        <!-- <link rel="inforWeeklyData.preview" href="styles.css" /> -->
        <iframe
          :src="inforWeeklyData.preview"
          width="898"
          class="thin-scrollbar iframe-container"
        ></iframe>
      </div>
    </div>
    <div v-if="blurMode"
      :class="['demomode-warning', 'flex-between']">
      <div>{{ $t("demomode.warning") }}</div>
    </div>
    <!-- <div class="mock-email" v-if="managerSelected && dateSelected">
      <div class="flex-mid center fc-15253C fs-20 body-email email-header">
        <div style="margin-top: 80px">
          <img
            style="width: 80px; height: 80px"
            src="../../assets/images/wv-monthly-insights/Icon.png"
            alt=""
          />
        </div>
      </div>
      <div class="flex-mid center fc-15253C fs-20 body-email">
        <div>
          <div class="mt-16">
            Your weekly team insights for
            <span class="fw-700">{{ dateSelected[0] }}</span>
          </div>
          <div class="italic">Customer Success</div>
        </div>
      </div>
      <div class="grid-4-25 fc-363636 body-email head-long">
        <div class="mx-auto center">
          <div>
            <span class="fw-700 mr-14" style="font-size: 33px">{{
              inforWeeklyData.weeklyActiveUser
            }}</span>
            <span
              :class="`${
                inforWeeklyData.weeklyActiveUserChanged > 0
                  ? 'fc-27BC6C'
                  : 'fc-F22F3C'
              } fs-12`"
              >{{
                inforWeeklyData.weeklyActiveUserChanged > 0
                  ? "+" + inforWeeklyData.weeklyActiveUserChanged
                  : inforWeeklyData.weeklyActiveUserChanged
              }}%</span
            >
          </div>
          <div class="fc-848484 fs-10">WEEKLY ACTIVE USERS</div>
        </div>
        <div class="mx-auto center">
          <div>
            <span class="fw-700 mr-14" style="font-size: 33px"
              >{{ inforWeeklyData.happinessRate }}%</span
            >
            <span
              :class="`${
                inforWeeklyData.happinessRateChanged > 0 ? 'fc-27BC6C' : 'fc-F22F3C'
              } fs-12`"
              >{{
                inforWeeklyData.weeklyActiveUserChanged > 0
                  ? "+" + inforWeeklyData.weeklyActiveUserChanged
                  : inforWeeklyData.weeklyActiveUserChanged
              }}%</span
            >
          </div>
          <div class="fc-848484 fs-10">HAPPINESS RATE</div>
        </div>
        <div class="mx-auto center">
          <div>
            <span class="fw-700 mr-14" style="font-size: 33px"
              >{{ inforWeeklyData.riskRate }}%</span
            >
            <span
              :class="`${
                inforWeeklyData.riskRateChanged > 0 ? 'fc-27BC6C' : 'fc-F22F3C'
              } fs-12`"
              >{{
                inforWeeklyData.weeklyActiveUserChanged > 0
                  ? "+" + inforWeeklyData.weeklyActiveUserChanged
                  : inforWeeklyData.weeklyActiveUserChanged
              }}%</span
            >
          </div>
          <div class="fc-848484 fs-10">RISK RATE</div>
        </div>
        <div class="mx-auto center">
          <div>
            <span class="fw-700 mr-14" style="font-size: 33px"
              >{{ inforWeeklyData.feedbackResponse }}%</span
            >
            <span
              :class="`${
                inforWeeklyData.feedbackResponseChanged > 0
                  ? 'fc-27BC6C'
                  : 'fc-F22F3C'
              } fs-12`"
              >{{
                inforWeeklyData.weeklyActiveUserChanged > 0
                  ? "+" + inforWeeklyData.weeklyActiveUserChanged
                  : inforWeeklyData.weeklyActiveUserChanged
              }}%</span
            >
          </div>
          <div class="fc-848484 fs-10">FEEDBACK RESPONSE</div>
        </div>
      </div>
      <div class="fc-FFFFFF px-40 body-email list">
        <div class="table-container p-40">
          <div class="fs-14 fw-700 center">TEAM OVERVIEW</div>
          <div class="team-overview-columns">
            <div></div>
            <div class="flex" style="height: 90px;">
              <div
                v-for="(value, index) in teamOverviewlabel"
                :key="'teamOverviewlabel_' + value"
                class="flex relative"
                style="width: 26px;"
                :style="`margin-right: ${index == 4? '30' : '6'}px;`"
              >
                <div class="header-label ellipsis fs-12">
                  {{ value }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(value, index) in teamOverviewData"
            :key="'content_overview_' + index"
            class="team-overview-columns"
          >
            <div :class="`ml-auto pr-28 flex-center ${index == 0 ? 'focus-left': ''}`">
              {{ value.teamName }}
            </div>
            <div :class="`flex mr-auto ${index == 0 ? 'focus-right': ''}`">
              <div
                v-for="(status, indexChild) in value.overview"
                :key="indexChild + '_status_' + status"
                :class="`status ${status} ${indexChild == 4 && index == 0 ? 'plus' : ''}`"
                :style="`margin-right: ${indexChild == 4? '30' : '3'}px;`"
              ></div>
            </div>
          </div>
        </div>
        <div class="table-container mt-12 pt-40">
          <div class="fs-14 fw-700 center">YOUR TO-DO 🎯 LIST</div>
          <div class="px-40 mx-40" v-if="toDoList.highestPriority > 1">
            <div class="fs-14 fw-500 fc-F22F3C mb-16 mt-12">
              🔥 HIGHEST PRIORITY
            </div>
            <div
              v-for="(vtext, index) in toDoList.highestPriorityVText"
              :key="'highest_task_' + index"
              class="flex mt-14"
            >
              <div class="check-box"></div>
              <div class="word-break v-text" v-html="vtext"></div>
            </div>
          </div>
          <div class="px-40 mx-40" v-if="toDoList.highestPriority > 1">
            <div class="fs-14 fw-500 opa-07 mb-16 mt-16">HIGH PRIORITY</div>
            <div
              v-for="(vtext, index) in toDoList.highPriorityVText"
              :key="'high_task_' + index"
              class="flex mt-14"
            >
              <div class="check-box"></div>
              <div class="word-break v-text" v-html="vtext"></div>
            </div>
          </div>
          <div class="completed">
            <div class="fs-14 fw-500 opa-07 mb-16 mt-16">
              COMPLETED FROM LAST WEEK
            </div>
            <div
              v-for="(vtext, index) in toDoList.completedVText"
              :key="'completed_task_' + index"
            >
              <div class="mt-14 flex" v-if="index < 2">
                <label class="container">
                  <input type="checkbox" checked="checked" disabled />
                  <span class="checkmark"></span>
                </label>

                <div
                  class="word-break fw-700 v-text"
                  style="text-decoration: line-through"
                  v-html="vtext"
                ></div>
              </div>
            </div>
            <div
              class="fs-16 fw-700 italic mt-16"
              v-if="toDoList.completed > 2"
            >
              …and {{ toDoList.completed - 2 }} other items
            </div>
          </div>
        </div>
      </div>
      <div class="body-email starperformers-head"></div>
      <div class="body-email starporformers-body">
        <div class="fc-4D4D4D center mt-40 mb-12">
          <div class="fs-24 fw-900">STARS PERFORMERS</div>
          <div class="fs-18">
            The Top 15% performers this week that are on your team
          </div>
        </div>
        <div v-for="user in starsPerformersUser" :key="user.id">
          <div class="profile top flex-center" style="height: 74px">
            <div v-if="user.image">
              <img
                v-lazy="user.image"
                :key="user.image"
                class="image-skeleton image-profile-60 flex-mid mr-16"
              />
            </div>
            <div v-else class="image image-profile-60 flex-mid mr-16">
              <div
                class="flex-mid text-in-image text-in-image-60"
                style="width: 60px"
              >
                {{
                  $utils("acronymName", {
                    firstName: user.firstname,
                    lastName: user.lastname,
                  })
                }}
              </div>
            </div>
            <div class="" style="min-width: 280px">
              <div class="fs-18 fw-700 fc-4D4D4D">
                {{ user.firstname + " " + user.lastname }}
              </div>
              <div class="fs-13" style="color: #aaa">
                {{ user.job }}
              </div>
            </div>
            <div style="widht: 180px">
              <div v-if="user.talent" class="talent">
                {{ user.talent }}
              </div>
            </div>
            <div class="flex-center ml-auto">
              <div v-if="user.starPerformer" class="flex-center">
                <div class="fc-FBB040" style="font-size: 35px">
                  <i class="el-icon-star-on"></i>
                </div>
                <span class="mr-4 fs-18">x </span>
                <span class="fs-20 fw-700">
                  {{ user.starPerformer }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-email healthcheck-head"></div>
      <div class="body-email healthcheck-body">
        <div class="center mt-40 mb-12 fc-FFFFFF">
          <div class="fs-24 fw-900">HEALTH CHECK</div>
          <div class="fs-18">
            Summary of people you’re at risk of losing from your team
          </div>
          <div class="flex-center mx-auto mt-16" style="width: 280px">
            <div class="health-des fs-12 flex-center">
              <div class="health-icon">
                <div class="fw-900 mt-6">!</div>
              </div>
              <div class="fw-700 ml-8 mt-4">LOW</div>
            </div>
            <div class="health-des fs-12 flex-center">
              <div class="health-icon">
                <div class="fw-900 mt-6">!!</div>
              </div>
              <div class="fw-700 ml-6 mt-4">MED</div>
            </div>
            <div class="health-des fs-12 flex-center">
              <div class="health-icon">
                <div class="fw-900 mt-6">!!!</div>
              </div>
              <div class="fw-700 ml-6 mt-4">HIGH</div>
            </div>
          </div>
        </div>
        <div v-for="user in healthCheckUser" :key="user.id">
          <div class="profile top flex-center" style="height: 74px">
            <div v-if="user.image">
              <img
                v-lazy="user.image"
                :key="user.image"
                class="image-skeleton image-profile-60 flex-mid mr-16"
              />
            </div>
            <div v-else class="image image-profile-60 flex-mid mr-16">
              <div
                class="flex-mid text-in-image text-in-image-60"
                style="width: 60px"
              >
                {{
                  $utils("acronymName", {
                    firstName: user.firstname,
                    lastName: user.lastname,
                  })
                }}
              </div>
            </div>
            <div class="" style="min-width: 380px">
              <div class="fs-18 fw-700 fc-FFFFFF">
                {{ user.firstname + " " + user.lastname }}
              </div>
              <div class="fs-13 fc-EAEAEA">
                {{ user.job }}
              </div>
              <div class="fs-14" style="color: #5f5f5f">
                Problem Areas:
                <span
                  v-for="(text, index) in user.problemAreas"
                  :key="text + index"
                  >{{ text
                  }}{{ index + 1 == user.problemAreas.length ? "" : "," }}
                </span>
              </div>
            </div>
            <div
              v-if="user.healthCheck"
              style="widht: 30px"
              class="health-icon icon-red flex-mid"
            >
              <div class="fs-12 fw-900 mt-2">
                {{ user.healthCheck }}
              </div>
            </div>
            <div
              v-if="user.starPerformer"
              style="color: #5f5f5f"
              class="flex-center ml-auto"
            >
              <div class="flex-center pt-4">
                <div class="mr-4" style="font-size: 30px">
                  <i class="el-icon-star-off"></i>
                </div>
                <span class="mr-4 fs-18">x </span>
                <span class="fs-20 fw-700">
                  {{ user.starPerformer }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="p-40 center fc-FFFFFF"
        style="
          background-color: #a5a5a5;
          padding-bottom: 80px;
          border-radius: 0 0 6px 6px;
        "
      >
        Happily <span style="color: red">♥</span> DHA Siamwalla
      </div>
    </div> -->
    <div
      v-else
       class="center fc-A0A0A0 fs-24 preview-reports mt-32"
    >
      <div v-if="!managerSelected || !dateSelected" style="padding-top: 80px">
        <!-- <i class="el-icon-folder-opened"></i> -->
        <div class="fs-16 fw-700 fc-000000 opa-04">
          {{ $t("reports.Preview_a_report_by") }} <br /> {{ $t("reports.from_the_above_menu") }}
        </div>
      </div>
      <div v-else-if="loadingWeeklyReportStatus" style="padding-top: 80px">
        <i class="el-icon-loading"></i>
        <div class="fs-16">{{ $t("reports.Loading") }}...</div>
      </div>
      <div
        style="padding-top: 80px"
        v-else-if="!loadingWeeklyReportStatus && !inforWeeklyData.preview"
      >
        <div class="fs-16">
          {{ $t("reports.Unable_to_preview_this") }}
        </div>
      </div>
    </div>
    <download-progress :active="showSnackbar"></download-progress>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import axios from 'axios'
export default {
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    this.$store.dispatch("reportPreview/getOrganization1level", this.user).then(()=>{
      this.$store.dispatch("reportPreview/getManagerOption", this.user)
    });
    //this.$store.dispatch("reportPreview/getManagerOption",this.user);
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    managerList() {
      return this.$store.getters["reportPreview/managerList"];
    },
    inforWeeklyData() {
      return this.$store.getters["reportPreview/inforWeeklyData"];
    },
    loadingWeeklyReportStatus() {
      return this.$store.getters["reportPreview/loadingWeeklyReportStatus"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  watch: {
    dateSelected() {
      this.getDataToPreview();
    },
    managerSelected() {
      this.getDataToPreview();
    }
  },
  data() {
    return {
      firstTimeloading: true,
      showSnackbar: false,
      // inforWeeklyData: {
      //   deliveryStatus: "undelivered", // Type : "none", "undelivered", "delivered"
      //   issue: "Hard Bounced", // "-"
      //   readStatus: "Opened by John Smith on July 2, 2021 at 9:34 AM", // "-"
      //   weeklyActiveUser: 18,
      //   weeklyActiveUserChanged: 12,
      //   happinessRate: 55,
      //   happinessRateChanged: 5,
      //   riskRate: 8,
      //   riskRateChanged: 3,
      //   feedbackResponse: 52,
      //   feedbackResponseChanged: 4,
      // },
      // toDoList: {
      //   highestPriority: 3,
      //   highestPriorityVText: [
      //     // <span class='fc-80F7F0'></span> || <span class='fw-700'></span>
      //     "<span class='fc-80F7F0'>Set up a 1:1 meeting</span> with <span class='fw-700'>Ittigorn T</span> to help <span class='fc-80F7F0'>share feedback</span> around “machine learning and forecasting” and help <span class='fc-80F7F0'></span>re-evaluate priorities to help manage stress to improve wellness",
      //     "<span class='fc-80F7F0'>Check-in</span> with <span class='fw-700'>Phudinun T</span> to see how they’re doing about “facing team challenges with recruiting”",
      //     "<span class='fc-80F7F0'>Share feedback</span> with <span class='fw-700'>Chanika K</span> on “the trial newsletters”",
      //   ],
      //   highPriority: 3,
      //   highPriorityVText: [
      //     "<span class='fc-80F7F0'>Send recognition</span> to <span class='fw-700'>Yuranan E</span> and <span class='fw-700'>Tarin G</span> for their recent efforts",
      //     "<span class='fc-80F7F0'>Re-evaluate priorities</span> with <span class='fw-700'>Apichaya P</span> to help manage stress to improve wellness",
      //     "<span class='fc-80F7F0'>Set up a team check-in</span> with the <span class='fw-700'>Customer Support</span> team to learn why Wellness is critical",
      //   ],
      //   completed: 6,
      //   completedVText: [
      //     "Set up a 1:1 meeting with Ittigorn T and Sarun S",
      //     "Check-in with Pailin C to see how they’re doing",
      //     "Check-in with Pailin C to see how they’re doing",
      //     "Check-in with Pailin C to see how they’re doing",
      //     "Check-in with Pailin C to see how they’re doing",
      //     "Check-in with Pailin C to see how they’re doing",
      //   ],
      // },
      // teamOverviewlabel: [
      //   "Happiness",
      //   "Feedback",
      //   "Rel. Manager",
      //   "Wellness",
      //   "Recognition",
      //   "Co. Alignment",
      // ],
      // teamOverviewData: [
      //   {
      //     teamName: "My Direct Reports",
      //     overview: ["yellow", "green", "green", "green", "yellow", "green"],
      //   },
      //   {
      //     teamName: "Customer Support",
      //     overview: ["green", "green", "red", "green", "yellow", "green"],
      //   },
      //   {
      //     teamName: "PR & Media",
      //     overview: ["yellow", "red", "yellow", "green", "yellow", "green"],
      //   },
      //   {
      //     teamName: "Admin",
      //     overview: ["yellow", "green", "green", "yellow", "green", "yellow"],
      //   },
      // ],
      // starsPerformersUser: [
      //   {
      //     firstname: "Lisa",
      //     lastname: "Coleman",
      //     id: "111",
      //     image: "",
      //     job: "PROJECT MANAGEMENT",
      //     talent: "Superstar",
      //     starPerformer: 3,
      //   },
      //   {
      //     firstname: "Mark",
      //     lastname: "de Silva",
      //     id: "112",
      //     image: "",
      //     job: "CUSTOMER SUPPORT",
      //     talent: "Rising Star",
      //     starPerformer: 2,
      //   },
      //   {
      //     firstname: "Lisa",
      //     lastname: "Coleman",
      //     id: "113",
      //     image: "",
      //     job: "ACCOUNT EXECS",
      //     talent: "Hidden Talent",
      //     starPerformer: 2,
      //   },
      //   {
      //     firstname: "Lisa",
      //     lastname: "Coleman",
      //     id: "114",
      //     image: "",
      //     job: "ACCOUNT EXECS",
      //     talent: "",
      //     starPerformer: 1,
      //   },
      // ],
      // healthCheckUser: [
      //   {
      //     firstname: "Lisa",
      //     lastname: "Coleman",
      //     id: "121",
      //     image: "",
      //     job: "PROJECT MANAGEMENT",
      //     healthCheck: "!",
      //     problemAreas: ["Feedback", "Wellness", "Rel. Managers"],
      //     starPerformer: 0,
      //   },
      //   {
      //     firstname: "Mark",
      //     lastname: "de Silva",
      //     id: "122",
      //     image: "",
      //     job: "CUSTOMER SUPPORT",
      //     healthCheck: "!!",
      //     problemAreas: ["Feedback", "Rel. Managers"],
      //     starPerformer: 1,
      //   },
      //   {
      //     firstname: "Lisa",
      //     lastname: "Coleman",
      //     id: "123",
      //     image: "",
      //     job: "ACCOUNT EXECS",
      //     healthCheck: "!!!",
      //     problemAreas: ["Feedback", "Wellness", "Rel. Managers"],
      //     starPerformer: 0,
      //   },
      //   {
      //     firstname: "Lisa",
      //     lastname: "Coleman",
      //     id: "124",
      //     image: "",
      //     job: "ACCOUNT EXECS",
      //     healthCheck: "!!",
      //     problemAreas: ["Feedback", "Wellness"],
      //     starPerformer: 0,
      //   },
      // ],
      managerSelected: "",
      // managerList: [
      //   {
      //     value: "id164asasdf13264",
      //     label: "Adison Riewthong",
      //   },
      //   {
      //     value: "id13564asd613264",
      //     label: "Chanitra Suthamma",
      //   },
      //   {
      //     value: "id112564614s3264",
      //     label: "Ittigorn Tradussadee",
      //   },
      //   {
      //     value: "id13561261f3264",
      //     label: "Kantamad Luemon",
      //   },
      // ],
      dateSelected: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      // dateList: [
      //   {
      //     value: "Monday, July 5, 2021",
      //     label: "Monday, July 5, 2021",
      //   },
      //   {
      //     value: "Monday, June 28, 2021",
      //     label: "Monday, June 28, 2021",
      //   },
      //   {
      //     value: "Monday, June 21, 2021",
      //     label: "Monday, June 21, 2021",
      //   },
      //   {
      //     value: "Monday, June 14, 2021",
      //     label: "Monday, June 14, 2021",
      //   },
      // ],
    };
  },
  methods: {
    disabledDate(date) {
      return new Date() < date || date < new Date("2021-08-31") || new Date(date).getDay() !== 1;
      // return new Date() < date || date < new Date("2021-08-31");
    },
    getDataToPreview() {
      if(this.managerSelected[0] && this.dateSelected){
        this.firstTimeloading = false;
        this.$store.dispatch("reportPreview/getDataPreview", {user:this.managerSelected[0], date: this.dateSelected, type: 'report_weekly_boss', loading: "Weekly",});
      }
    },
    filterManagerFunction(node, keyword) {
      let keywordArr = keyword.split(" ");
      if (keywordArr.length > 1) {
        for (let i = 0;i < keywordArr.length; i++) {
            if (
              node.data.firstname.toLowerCase().indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname.toLowerCase().indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            }
        }
      } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
      }
    },
    async exportReport() {
      let file = ''
      file = this.inforWeeklyData.file
      if(file && !this.showSnackbar){
        this.showSnackbar = true
        axios({
          method: "get",
          url: file
        })
          .then(result => {
            let body = document.body
            let html = document.documentElement
            let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
            let heightCM = height / 35.35
            let resultData = result.data
            const regex = /[(http(s)?):\/\/(www\.)?-a-zA-Z0-9@:%.\+#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\+.#?&//=]*)/ig
            const found = resultData.match(regex)
            for(const x in found){
              const sp = found[x].split('connected-pub.s3.ap-southeast-1.amazonaws.com/happily/')
              if(sp.length > 1){
                let name = sp[1]
                name = name.replace(/\//g, '%2F')
                let text = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name}?alt=media`
                resultData = resultData.replace(found[x],text)
              }
              const sp2 = found[x].split('s3-ap-southeast-1.amazonaws.com/connected-pub/happily/')
              if(sp2.length > 1){
                let name2 = sp2[1]
                name2 = name2.replace(/\//g, '%2F')
                let text2 = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name2}?alt=media`
                resultData = resultData.replace(found[x],text2)
              }
              const sp3 = found[x].split('connected-pub.s3-ap-southeast-1.amazonaws.com/happily/')
              if(sp3.length > 1){
                let name3 = sp3[1]
                name3 = name3.replace(/\//g, '%2F')
                let text3 = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name3}?alt=media`
                resultData = resultData.replace(found[x],text3)
              }
            }
            html2pdf(resultData, {
              margin: 1,
              filename: `${this.inforWeeklyData.file_name}.pdf`,
              html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
              jsPDF: {
                orientation: 'portrait',
                unit: 'cm',
                format: [heightCM, 27.093333333]
              }
            })
            setTimeout(() => {
              this.showSnackbar = false
            }, 5000);
          })
          .catch(error => {
            console.error("error getting file");
          });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.preview-reports {
  height: 709px;
  background-color: rgba($color: #000000, $alpha: 0.06);
  border-radius: 4px;
}
.line-section {
  margin: 20px 0;
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
}
.table-container {
  background-color: #2f2f45;
  border-radius: 12px;
  .v-text {
    width: calc((100% - 18px) - 15px);
  }
  .check-box {
    width: 18px;
    height: 18px;
    border-radius: 3px;
    margin-right: 15px;
    border: 2px solid #fff;
  }
  .completed {
    margin-top: 32px;
    padding: 32px 80px 40px;
    background-color: #20202e;
    border-radius: 0 0 12px 12px;

    .container {
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }
    }

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 20px;
      width: 20px;
      border-radius: 3px;
      background-color: #fff;

      &:after {
        content: "";
        position: absolute;
        display: none;
      }
    }

    .container:hover input ~ .checkmark {
      background-color: #ccc;
    }

    .container input:checked ~ .checkmark {
      background-color: #fff;
    }

    .container input:checked ~ .checkmark:after {
      display: block;
    }

    .container .checkmark:after {
      left: 7px;
      top: 2px;
      width: 4px;
      height: 9px;
      border: solid #20202e;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}
#weeklyReports {
  .team-overview-columns {
    display: grid;
    grid-template-columns: 40% 60%;
    .focus-left, .focus-right {
      background-color: #535353;
    }
    .focus-left {
      padding: 2px 28px 2px 30px;
      border-radius: 30px 0 0 30px;
    }
    .focus-right {
      padding: 0 5px 2px 2px;
      border-radius: 0 30px 30px 0;
    }
    .header-label {
      bottom: 40px;
      position: absolute;
      transform: rotate(-45deg);
      width: 100px;
      color: #939393;
    }
    .status {
      margin: 3px;
      width: 26px;
      height: 26px;
      border-radius: 26px;
      background-color: #939393;
    }
    .status.plus {
      position: relative;
      &::before {
        content: "+";
        position: absolute;
        color: #B9B9B9;
        font-size: 20px;
        right: -23px;
        top: 3px;
      }
    }
    .status.green {
      background-color: #27BC6C;
    }
    .status.yellow {
      background-color: #FFBA0D;
    }
    .status.red {
      background-color: #F22F3C;
    }
  }
  .mock-email {
    background-color: #75d1f6;
    border-radius: 6px;
    margin-top: 32px;

    .body-email {
      background: #fff;
      margin: auto;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .body-email.list {
      width: 680px;
    }
    .body-email.head-long {
      width: calc(100% - 320px);
      padding: 90px 160px 40px;
      margin: 24px 0;
      background-image: url("../../assets/images/reports/weekly-activity-head-long.png");
    }

    .body-email.starperformers-head,
    .body-email.healthcheck-head {
      background-position: top;
      background-size: contain;
      padding: 0 0 40px;
      width: 898px;
      height: 140px;
    }
    .body-email.email-header {
      background-image: url("../../assets/images/reports/cloud-header.png");
    }
    .body-email.starperformers-head {
      background-image: url("../../assets/images/reports/starperformers-head@2x.png");
      margin: 14px 0 -44px;
    }
    .body-email.healthcheck-head {
      background-image: url("../../assets/images/reports/healthcheck-head@2x.png");
      background-color: #fff;
      margin: 0 0 -55px;
    }
    .body-email.healthcheck-body {
      background-color: #a5a5a5;
      padding: 0 160px 0px;
    }

    .body-email.starporformers-body {
      background-color: #ffffff;
      padding: 0 160px 40px;
    }

    .talent {
      background-color: #6c30cc;
      border-radius: 14px;
      padding: 4px 12px;
      width: 110px;
      text-align: center;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .health-des {
    width: 72px;
    height: 24px;
    border-radius: 24px;
    background-color: #bcbcbc;
    color: #fff;
    margin: auto;
  }
  .health-icon {
    width: 24px;
    height: 24px;
    border-radius: 24px;
    color: #fff;
    background-color: #939393;
  }
  .icon-red {
    background-color: red;
  }
  .status {
    width: 16px;
    height: 16px;
    border-radius: 16px;
  }
  .status-gray {
    background-color: #dbdbdb;
  }
  .status-red {
    background-color: #f44336;
  }
  .status-green {
    background-color: #66bb6a;
  }
  .status-yellow {
    background-color: #ffba0d;
  }
  .el-cascader-node__label {
    font-size: 18px;
  }
}
.demomode-warning {
  border: #f5184c solid 2px;
  border-radius: 3px;
  background-color: #f72d3d;
  color: #ffffff;
  font-size: 13px;
  font-family: "Roboto";
  font-weight: 500;
  padding: 9px 15px;
  margin: 27px 0px 13px;
  opacity: 0.8;
}
</style>